import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class segmentoSunatService {

    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/segmento-sunat`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new segmentoSunatService();